import type { RedirectionTrackingServiceConfig } from '@core/services/redirection/redirection-tracking-service.config';

import { inject, Injectable } from '@angular/core';
import { AwinService } from '@core/services/awin.service';
import { environment } from '@environment';
import { trackEvent, trackIbanReturned, trackPartnerExposition, trackRedirect } from '@wizbii/utils/tracking';

@Injectable({
  providedIn: 'root',
})
export class RedirectionTrackingService implements RedirectionTrackingServiceConfig {
  readonly awinService = inject(AwinService);

  readonly trackRedirectFromCookieModal = (stepSlug: string): void => {
    trackEvent('BankingPartnerCookieModal', 'Redirect', stepSlug);
  };

  readonly trackOpenModal = (stepSlug: string): void => {
    trackEvent('BankingPartnerCookieModal', 'Open modal', stepSlug);
  };
  readonly trackCloseModal = (stepSlug: string): void => {
    trackEvent('BankingPartnerCookieModal', 'Close modal', stepSlug);
  };

  readonly trackExternalRedirect = (stepSlug: string): void => {
    trackEvent('BankingOnboardingPlayer', 'External redirect', stepSlug);
  };

  readonly trackKnowMore = (stepSlug: string): void => {
    trackEvent('BankingOnboardingPlayer', 'Know more', stepSlug);
  };
  readonly knowMoreUnderstood = (stepSlug: string): void => {
    trackEvent('External redirect step', 'Know more understood', stepSlug);
  };
  readonly trackKnowMoreClose = (stepSlug: string): void => {
    trackEvent('External redirect step', 'Know more closed', stepSlug);
  };
  readonly trackKnowMoreCgu = (stepSlug: string): void => {
    trackEvent('External redirect step', 'Know more cgu', stepSlug);
  };

  readonly trackAlreadyClient = (partnerLabel: string): void => {
    trackEvent('BankingOnboardingPlayer', 'Already partner client', partnerLabel);
  };

  readonly trackShowOtherPartners = (): void => {
    trackEvent('BankingOnboardingPlayer', 'Show other partners');
  };

  readonly trackBforBankCloseWithoutResponse = (stepSlug: string): void => {
    trackEvent('BankingOnboardingPlayer', 'BforBank consent modal closed without response', stepSlug);
  };
  readonly trackBforBankConsentAccepted = (stepSlug: string): void => {
    trackEvent('BankingOnboardingPlayer', 'BforBank consent accepted', stepSlug);
  };
  readonly trackBforBankConsentDeclined = (stepSlug: string): void => {
    trackEvent('BankingOnboardingPlayer', 'BforBank consent declined', stepSlug);
  };
  readonly trackBforBankConsentModalClosed = (stepSlug: string): void => {
    trackEvent('BankingOnboardingPlayer', 'BforBank consent modal closed', stepSlug);
  };
  readonly trackBforBankConsentFromModal = (stepSlug: string, hasConsented: boolean): void => {
    trackEvent('Orders', `BforBank consent ${hasConsented ? 'accepted' : 'declined'} from modal`, stepSlug);
  };

  readonly trackBforBankCookieModalClickCta = (stepSlug: string): void => {
    trackEvent('BankingOnboardingPlayer', `BforBank cookie modal click cta`, stepSlug);
  };
  readonly trackBforBankExternalRedirect = (stepSlug: string): void => {
    trackEvent('BankingOnboardingPlayer', 'BforBank External redirect', stepSlug);
  };

  readonly trackConditionsClick = (): void => {
    trackEvent('BankingOnboardingPlayer', 'Click Conditions Générales');
  };

  readonly trackRedirect = (partnerId: string): void => {
    this.awinService.track('Redirection');

    trackRedirect({
      send_to: environment.googleSendTo.redirection,
      items: [{ item_id: partnerId, item_name: partnerId }],
    });
  };

  readonly trackPartnerExposition = (): void => {
    trackPartnerExposition({ send_to: environment.googleSendTo.partnerExposition, value: 5, currency: 'EUR' });
    this.awinService.track('Partner_Exposition');
  };

  readonly trackIbanReturned = (): void => {
    trackIbanReturned({ send_to: environment.googleSendTo.ibanReturned, value: 50, currency: 'EUR' });
    this.awinService.track('IBAN_returned');
  };
}
